<template>
    <div>
        <dx-grid
            name="tip-transactions-grid"
            :beforeSetupGrid="beforeSetupGrid"
            :url="tipTransactionUrl"
            :columns="tipTransactionColumns"
            title="Tip Transactions"
            ref="tipTransactionGrid"
            :actions="actions"
            :expandedOptions="{
                enabled: true,
                allowExpandingAll: true,
                template: 'tip-transaction-details',
            }"
            :summaryOptions="{
                enabled: true,
                columns: ['amount'],
            }"
        ></dx-grid>

        <v-dialog v-model="printReportDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Download Statement Report</v-card-title
                >
                <v-select
                    label="Report"
                    ref="report"
                    color="success"
                    :items="reports.map((r) => r.displayName)"
                    v-model="reportSelected"
                    :rules="[rules.required]"
                ></v-select>

                <div v-if="getSelectedReport()" class="mb-1">
                    <span class="font-weight-medium mr-1">From:</span>
                    {{ getSelectedReport().fromDate }}
                </div>
                <div v-if="getSelectedReport()" class="mb-2">
                    <span class="font-weight-medium mr-1">To:</span>
                    {{ getSelectedReport().toDate }}
                </div>
                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="printReportDialog = false"
                        color="default"
                        dark
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="printReport"
                    >
                        download
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="generateReportDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Generate Statement Report</v-card-title
                >
                <v-text-field
                    label="Description"
                    ref="description"
                    color="success"
                    v-model="generateReportSettings.description"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-menu
                    v-model="generateReportSettings.fromDatePicker"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="generateReportSettings.fromDate"
                            label="From Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="generateReportSettings.fromDate"
                    ></v-date-picker>
                </v-menu>
                <v-menu
                    v-model="generateReportSettings.toDatePicker"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="generateReportSettings.toDate"
                            label="To Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="generateReportSettings.toDate"
                    ></v-date-picker>
                </v-menu>
                <v-menu
                    v-model="generateReportSettings.statementDatePicker"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="generateReportSettings.statementDate"
                            label="Statement Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="generateReportSettings.statementDate"
                    ></v-date-picker>
                </v-menu>
                <v-text-field
                    label="Message"
                    ref="message"
                    color="success"
                    v-model="generateReportSettings.message"
                ></v-text-field>
                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="generateReportDialog = false"
                        color="default"
                        dark
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="generateReport"
                    >
                        Generate
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { formatCurrency, toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Tip Transactions",
        tipTransactionUrl: "",
        actions: [],
        fromDate: "",

        processing: false,
        printReportDialog: false,
        generateReportDialog: false,

        reports: [],
        reportSelected: "",

        generateReportSettings: {
            fromDate: "",
            fromDatePicker: false,
            toDate: toISOLocal(new Date(moment())).substr(0, 10),
            toDatePicker: false,
            statementDate: toISOLocal(new Date(moment())).substr(0, 10),
            statementDatePicker: false,
            description: "",
            message: "",
        },

        rules: {
            required: (value) => !!value || "Required.",
        },

        tipTransactionColumns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "PROCESSED":
                            return "mdi-check-circle";
                        case "SCHEDULED":
                            return "mdi-clock";
                        case "VOIDED":
                        case "CANCELED":
                            return "mdi-cancel";
                        case "ERROR":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "PROCESSED":
                            return "success";
                        case "SCHEDULED":
                            return "#fdb400";
                        case "VOIDED":
                        case "CANCELED":
                            return "#aeb8bf";
                        case "ERROR":
                            return "#f35123";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Employee ID",
                field: "employeeID",
                visible: true,
                link: "TeacherView",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Name",
                field: "studentName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Type",
                field: "paymentType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mailing Address",
                field: "mailingAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Type",
                field: "teacherType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "grade",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Read",
                field: "read",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Notified",
                field: "notified",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Paid",
                field: "isPaid",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "From Schedule",
                field: "fromSchedule",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Date",
                field: "paymentDate",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.loadReports();
    },
    methods: {
        beforeSetupGrid() {
            this.fromDate = toISOLocal(
                new Date(moment().subtract(1, "weeks")),
            ).substr(0, 10);

            this.actions.push({
                text: "From Date",
                type: "datepicker",
                value: this.fromDate,
                onChanged: this.onDateChanged,
                action: this.onDateChanged,
                align: "left",
            });

            this.actions.push({
                text: "Download Statement Report",
                name: "PrintReport",
                action: this.openPrintReport,
            });

            this.actions.push({
                text: "Generate Statement Report",
                name: "GenerateReport",
                action: this.openGenerateReport,
            });

            this.tipTransactionUrl =
                "tipTransactions?fromDate=" + this.fromDate + "&employeeID=";
        },
        onDateChanged(value) {
            this.fromDate = value;
            this.tipTransactionUrl =
                "tipTransactions?fromDate=" + this.fromDate + "&employeeID=";

            this.$refs.tipTransactionGrid.reloadDataSource(
                this.tipTransactionUrl,
            );
        },
        async loadReports() {
            const response = await this.$http.get(
                "api/tipTransactions/getReports",
            );

            this.reports = response.map((report) => {
                report.displayName =
                    report.description +
                    " (" +
                    moment(report.statementDate).format("L") +
                    ")";

                report.fromDate = moment(report.fromDate).format("L");
                report.toDate = moment(report.toDate).format("L");

                return report;
            });
        },
        async openPrintReport() {
            await this.loadReports();

            this.printReportDialog = true;
        },
        async openGenerateReport() {
            const response = await this.$http.get(
                "api/tipTransactions/getFirstTipNotOnStatement",
            );

            this.generateReportSettings.fromDate = response
                ? toISOLocal(new Date(moment(response))).substr(0, 10)
                : "";

            this.generateReportDialog = true;
        },
        getSelectedReport() {
            if (!this.reportSelected) return;

            return this.reports.find(
                (r) => r.displayName == this.reportSelected,
            );
        },
        async generateReport() {
            if (!this.$refs.description.validate(true)) return;

            if (!this.generateReportSettings.fromDate) {
                return this.$notify({
                    group: "notification",
                    text: "From Date Missing",
                    type: "error",
                });
            }

            if (!this.generateReportSettings.toDate) {
                return this.$notify({
                    group: "notification",
                    text: "To Date Missing",
                    type: "error",
                });
            }

            if (!this.generateReportSettings.statementDate) {
                return this.$notify({
                    group: "notification",
                    text: "Statement Date Missing",
                    type: "error",
                });
            }

            if (
                new Date(this.generateReportSettings.fromDate) >
                new Date(this.generateReportSettings.toDate)
            ) {
                return this.$notify({
                    group: "notification",
                    text: "'From Date' must be before 'To Date' Missing",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/tipTransactions/generateStatementReport",
                    {
                        user: this.$store.state.authentication.user,
                        fromDate: moment(
                            this.generateReportSettings.fromDate,
                        ).format("YYYY-MM-DD HH:mm:ss"),
                        toDate: moment(
                            this.generateReportSettings.toDate,
                        ).format("YYYY-MM-DD HH:mm:ss"),
                        statementDate: moment(
                            this.generateReportSettings.statementDate,
                        ).format("YYYY-MM-DD HH:mm:ss"),
                        description: this.generateReportSettings.description,
                        message: this.generateReportSettings.message,
                    },
                );

                this.$notify({
                    group: "notification",
                    text: "Report Generated",
                    type: "success",
                });

                this.processing = false;
                this.generateReportDialog = false;

                this.generateReportSettings.fromDate = "";
                this.generateReportSettings.toDate = "";
                this.generateReportSettings.statementDate = toISOLocal(
                    new Date(moment()),
                ).substr(0, 10);
                this.generateReportSettings.description = "";
                this.generateReportSettings.message = "";

                this.$refs.tipTransactionGrid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async printReport() {
            if (!this.reportSelected) {
                return this.$notify({
                    group: "notification",
                    text: "Please Select Report",
                    type: "error",
                });
            }

            const id = this.reports.find(
                (r) => r.displayName == this.reportSelected,
            ).statementBatchID;

            try {
                this.processing = true;

                const response = await this.$http({
                    url: "api/tipTransactions/downloadStatementReport?id=" + id,
                    method: "POST",
                    data: {},
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Statement Report.pdf");
                document.body.appendChild(link);
                link.click();

                this.processing = false;
                this.downloadReportDialog = false;
                //this.$refs.tipTransactionGrid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
